<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">

      <section class="talkshow talkshowExhibitors">

        <div class="talkshowTitle">
          <div class="inner4">
            <h1>出展者自主企画イベント</h1><p class="titleSub">Independent Event Organized by Exhibitors</p>
          </div><!-- /inner4-->
        </div><!-- /talkshowTitle-->

        <div class="talkshowAbout">
          <div class="inner4">
            <p>
            東京カメラ部10選やコンテスト入賞者など、写真展の出展者が企画するイベント、お知らせを掲載しています。<br>
            企画は東京カメラ部が運営しているものではありませんので、お問い合わせや、万が一トラブルが発生した場合は、直接主催者にご連絡いただくようお願いいたします。
            </p>
          </div><!-- /inner-->
        </div><!-- /talkshowAbout-->


          <div v-if="!exhibitorEvents[0] || !hasSchedule()">
            <div class="exhibitorsList">
              <div class="inner4">
                <h3>
                  予定されているイベントはありません
                </h3>
              </div>
            </div>
          </div>

          <div v-else>
            <div class="exhibitorsList">
              <div class="inner4">
                <template v-for="exhibitorEvent in exhibitorEvents">
                  <div class="exhibitorsListBlock" v-if="isScheduledTime(exhibitorEvent.endAt)" :key="exhibitorEvent.id">
                    <div class="exhibitorsListHead" style="cursor: pointer;" @click="openLiveLink(exhibitorEvent)">
                      <img class="status2" src="/img2022/eventCalendarIcon_link.png"  alt="" /> 
                      <h3>{{exhibitorEvent.title}}</h3>
                    </div>
                    <div class="exhibitorsListBody" >
                      <p class="date">{{getDispDate(exhibitorEvent)}}</p>
                      <p class="organizer">主催者：<router-link :to="getWinnerLink(exhibitorEvent.winnerId)">{{exhibitorEvent.winnerName}}</router-link></p>
                      <p class="about">{{exhibitorEvent.description}}</p>
                    </div>
                  </div>
                </template>
               </div>
             </div>
          </div>




      </section>
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
    <ExternalSiteAlertDialog :isOpen.sync="isExternalSiteAlertOpen" :link="externalSiteLink"/>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import UpButton from '@/components/modules/UpButton.vue'
import WinnerLinkUtil from '@/util/WinnerLinkUtil'
import ExternalSiteAlertDialog from '@/components/modules/ExternalSiteAlertDialog.vue'

export default {
  components: {
    Header,
    Footer,
    UpButton,
    ExternalSiteAlertDialog
  },
  data () {
    return {
      nowDateTime: null,
      timerId: null,
      holidayList: ['2022-09-19', '2022-09-23', '2022-10-10'],
      // 外部サイトリンク警告
      isExternalSiteAlertOpen: false,
      externalSiteLink: ''
    }
  },
  created () {
    this.setNow()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    // トークショーが終了している場合falseを返す
    isScheduledTime (endTime) {
      if (this.nowDateTime > moment(endTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    hasSchedule () {
      if (this.nowDateTime > moment(this.exhibitorEvents.slice(-1)[0].endAt, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    isOnAir (exhibitorEvent) {
      if (this.nowDateTime < moment(exhibitorEvent.startAt).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      if (this.nowDateTime > moment(exhibitorEvent.endAt).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
        return false
      }
      return true
    },
    getDispDate(exhibitorEvent) {
      let dispDate = moment(exhibitorEvent.startAt).tz('Asia/Tokyo').format('M月D日（ddd）')
      if (this.holidayList.indexOf(exhibitorEvent.startAt.substring(0, 10)) >= 0) {
        dispDate = dispDate.slice(0, -1) + '・祝）'
      }
      dispDate += ' ' + moment(exhibitorEvent.startAt).tz('Asia/Tokyo').format('HH:mm') + '~' + moment(exhibitorEvent.endAt).tz('Asia/Tokyo').format('HH:mm')
      return dispDate
    },
    openLiveLink (exhibitorEvent) {
      if (!exhibitorEvent.liveLink) {
        this.externalSiteLink = 'https://www.instagram.com/tokyocameraclub/'
        this.isExternalSiteAlertOpen = true
      } else {
        this.externalSiteLink = exhibitorEvent.liveLink
        this.isExternalSiteAlertOpen = true
      }
    },
    getWinnerLink (id) {
      const winner = this.winnersById(id)
      return WinnerLinkUtil.getUrl(winner)
    }
  },
  computed: {
    ...mapGetters([
      'exhibitorEvents',
      'winnersById'
    ])
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.inline{
  display: inline-block;
  _display: inline;
}
.clickDisable {
  pointer-events: none;
}

</style>
